@if (!levels().length) {
    <div class="wrapper empty-state-wrapper flex items-center justify-center flex-col">
        <img class="room-by-room-logo mb-3" src="/assets/room-by-room/rbr-images/room-by-room-logo.png" alt="" />
        <h3 class="mb-4">{{ 'RBR.START' | translate }}</h3>
        <p class="ca-text-md mb-5">{{ 'RBR.START_DESCRIPTION' | translate }}</p>

        <button mat-flat-button class="ca-button ca-button-s" (click)="initLevels()">
            <ca-icon icon="big-plus" class="ca-icon-s"></ca-icon><span> {{ 'RBR.LEVEL_LIST.ADD_ROOMS' | translate }} </span>
        </button>
    </div>
} @else {
    <div class="mb-4 wrapper results">
        <span class="cooling-load"
            ><span class="ca-text-tertiary">{{ 'RBR.LEVEL_LIST.SUMMARY.TOTAL_COOLING_LOAD' | translate }}</span>
            <span class="ca-bold ms-2 calculation-value"
                >{{ calculationSummary.totalCoolingLoad }} {{ 'MEASUREMENT_UNITS.KW' | translate }}</span
            >
        </span>
        <span class="heat-load"
            ><span class="ca-text-tertiary">{{ 'RBR.LEVEL_LIST.SUMMARY.TOTAL_HEAT_LOAD' | translate }}</span>
            <span class="ca-bold ms-2 calculation-value"
                >{{ calculationSummary.totalHeatLoad }} {{ 'MEASUREMENT_UNITS.KW' | translate }}</span
            ></span
        >
        <div class="divider"></div>
        <span class="living-area"
            ><span class="ca-text-tertiary">{{ 'RBR.LEVEL_LIST.SUMMARY.TOTAL_LIVING_AREA' | translate }}</span>
            <span class="ca-bold ms-2 calculation-value"
                >{{ calculationSummary.totalLivingArea }} {{ 'MEASUREMENT_UNITS.M2' | translate }}</span
            ></span
        >
        <span class="leftover-area"
            ><span class="ca-text-tertiary">{{ 'RBR.LEVEL_LIST.SUMMARY.LEFTOVER_AREA' | translate }}</span>
            <span class="ca-bold ms-2 calculation-value"
                >{{ calculationSummary.leftoverArea }} {{ 'MEASUREMENT_UNITS.M2' | translate }}</span
            ></span
        >
        <rbr-calculation-base />
    </div>
    <rbr-default-values />
    <div class="flex items-center justify-center mb-2 wrapper pseudo-button" (click)="addUpperLevel()">
        <button #addUpperLevelButton mat-button class="ca-button ca-button-xs md:my-auto">
            <ca-icon icon="big-plus" class="ca-icon-s"></ca-icon> <span>{{ 'RBR.BUTTON.ADD_UPPER_LEVEL' | translate }}</span>
        </button>
    </div>
    @for (level of levels(); track level.id) {
        <rbr-level-rooms-panel
            class="block mb-2"
            [levels]="levels()"
            [level]="level"
            (deleteLevel)="deleteLevel(level.id)"
            (addRooms)="onAddRooms($event)"
        ></rbr-level-rooms-panel>
    }
    <div class="flex items-center justify-center wrapper pseudo-button" (click)="addLowerLevel()">
        <button #addLowerLevelButton mat-button class="ca-button ca-button-xs md:my-auto">
            <ca-icon icon="big-plus" class="ca-icon-s"></ca-icon> <span>{{ 'RBR.BUTTON.ADD_LOWER_LEVEL' | translate }}</span>
        </button>
    </div>
}
